import { render, staticRenderFns } from "./NonStandardProduct.vue?vue&type=template&id=2f3dd08c&"
import script from "./NonStandardProduct.vue?vue&type=script&lang=js&"
export * from "./NonStandardProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports